exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ais-SearchBox[data-v-f4a8f400] {\n  margin-left: -20px;\n  margin-right: -20px;\n}\n@media (min-width: 768px) {.ais-SearchBox[data-v-f4a8f400] {\n    margin-left: 0;\n\n    margin-right: 0\n}\n}\nform[data-v-f4a8f400] {\n  height: 60px;\n}\ninput[data-v-f4a8f400],\nbutton[data-v-f4a8f400] {\n  outline: none !important;\n}\n", ""]);

// exports
